import React from 'react';

import "./About.css"

const About = () => {
    return (
        <div className="about-content">
            <h2>About Me</h2>
            <p>I'm a recent Computer Science graduate from the University of Leeds with practical experience in various areas of software engineering, gained through academic projects and personal initiatives. 
                I'm passionate about building reliable, user-focused software and continuously expanding my skill set.
            </p>

            <p>I'm actively seeking a graduate role in software engineering where I can contribute to impactful projects and grow as a developer.</p>
            
            <p>Feel free to explore the sections in the sidebar to learn more about my work and background.</p>
        </div>
    );
};

export default About;
